import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "star-on",
  "use": "star-on-usage",
  "viewBox": "0 0 20 19.38",
  "content": "<symbol viewBox=\"0 0 20 19.38\" id=\"star-on\"><title>star-on</title><path d=\"M4.74,19.68a1.43,1.43,0,0,1-.82-.25,1.37,1.37,0,0,1-.57-1.34l.89-5.31a0,0,0,0,0,0,0L.4,8.92a1.33,1.33,0,0,1-.33-1.4,1.44,1.44,0,0,1,1.11-.92l5.24-.78,0,0L8.73,1.09a1.42,1.42,0,0,1,2.55,0l2.27,4.71a0,0,0,0,0,0,0l5.23.78a1.35,1.35,0,0,1,.79,2.3l-3.83,3.82a.06.06,0,0,0,0,.05l.89,5.29a1.36,1.36,0,0,1-.56,1.34,1.45,1.45,0,0,1-1.5.09L10,17.05l0,0L5.42,19.51A1.43,1.43,0,0,1,4.74,19.68Z\" transform=\"translate(0 -0.31)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/star-on.svg
// module id = wOTZ
// module chunks = 264